import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaCheckCircle } from 'react-icons/fa';
import CustomButton from '../CustomButton';
import './VerifyProfileInfoModal.css';

const VerifyProfileInfoModal = ({ show, onHide, onVerifyNow }) => {
  return (
    <Modal show={show} onHide={onHide} centered className="verify-profile-info-modal">
      <Modal.Body className="verify-profile-info-modal-body">
        <button className="verify-profile-info-close-btn" onClick={onHide} aria-label="Close">
          <FaTimes />
        </button>
        <div className="verify-profile-info-content">
          <h4 className="verify-profile-info-title">Verify Your Profile</h4>
          <p className="verify-profile-info-subtitle"><strong>Let&apos;s Plan a Date</strong> values authenticity</p>

          <div className="verify-profile-info-benefits-card">
            <div className="verify-profile-benefit-item">
              <FaCheckCircle className="verify-profile-benefit-icon" />
              <div>
                <h5>Show You&apos;re Real</h5>
                <p>Let others know it&apos;s really you in your photos. Get More Responses</p>
              </div>
            </div>
            <div className="verify-profile-benefit-item">
              <FaCheckCircle className="verify-profile-benefit-icon" />
              <div>
                <h5>Get More Responses</h5>
                <p>Get more attention. Verified members are prioritized in search</p>
              </div>
            </div>
            <div className="verify-profile-benefit-item">
              <FaCheckCircle className="verify-profile-benefit-icon" />
              <div>
                <h5>100% Confidential</h5>
                <p>Your selfie remains private. No one will be able to view it on your profile</p>
              </div>
            </div>
          </div>

          <div className="verify-profile-actions">
            <CustomButton
              onClick={onVerifyNow}
              className="verify-profile-get-verified-btn"
            >
              Get Verified
            </CustomButton>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VerifyProfileInfoModal;

